<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="800">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-pencil</v-icon>
            {{ edit ? "Editar" : "Cadastrar" }} Eixo Temático
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-form ref="form" v-if="visible">
            <v-row class="d-flex justify-center">
              <v-col cols="12">
                <v-text-field
                  v-model="content.nome"
                  label="Descrição Eixo Temático"
                  counter="300"
                  outlined
                  dense
                  :rules="[(v) => $required(v), (v) => $max(v, 300)]"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="d-flex justify-center">
              <avp-select-ano-semestre
                :cols="12"
                :active="!edit"
                :sufix="'do Ciclo'"
                required
                v-model="content"
              ></avp-select-ano-semestre>
            </v-row>
            <v-row class="d-flex justify-center">
              <v-col cols="12">
                <v-select
                  v-model="content.trilhaItens"
                  label="Trilha Aprendizagem"
                  multiple
                  outlined
                  :items="form.lists.listTrilhasAprendizagem"
                  :item-text="'descricao'"
                  :item-value="'trilhaId'"
                ></v-select>
              </v-col>
            </v-row>
          </v-form>
        </div>
        <avp-buttons
          @click="salvar()"
          @cancel="$emit('onClose')"
          :actionText="'Salvar'"
        ></avp-buttons>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps, EixoTematico } from "~/commons/classes";

export default {
  props: new DialogProps(EixoTematico),
  data: () => ({
    form: {
      lists: {
        listTrilhasAprendizagem: [],
      },
    },
  }),
  methods: {
    salvar() {
      const save = () => {
        return this.$swal({
          text: `Deseja confirmar ${
            this.edit ? "a alteração" : "o cadastro"
          } do Eixo Temático?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: `Confirmar`,
          cancelButtonText: `Cancelar`,
        }).then(() => {
          return this.edit
            ? this.$editarEixoTematico(this.content, this.content.id)
            : this.$cadastrarEixoTematico(this.content);
        });
      };
      if (this.$validarFormulario()) {
        save().then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.$emit("onClose");
          this.$emit("onSave");
        });
      }
    },
  },
  mounted() {
    this.$obterTodasTrilhasDeAprendizagem().then(({ data }) => {
      this.form.lists.listTrilhasAprendizagem = data.trilhasDeAprendizagens;
    });
  },
};
</script>
